import {Component, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/stepper';
import {NotificationService} from "../../../services/common/notification.service";
import {TextTypeService} from "src/app/services/text/text-type.service";
import {TextTypeDto} from "../../../dtos/text/text-type/text-type-dto";
import {FormOptionsLists} from "../../../shared/FormOptionsLists";
import {References} from "../../../dtos/references";
import {SharedService} from "../../../services/common/shared.service";

export interface DialogData {
  id?: number;
}

@Component({
  selector: 'app-new-text-type',
  templateUrl: './new-text-type.component.html',
  styleUrls: ['./new-text-type.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NewTextTypeComponent implements OnInit {

  @ViewChild('stepper') stepper: MatStepper;

  formOptionsLists = new FormOptionsLists();
  modesList = this.formOptionsLists.modes;
  domainsList = this.formOptionsLists.domains;
  interactionsList = this.formOptionsLists.interactions
  mediasList = this.formOptionsLists.media;
  representationsList = this.formOptionsLists.representations
  purposesList = this.formOptionsLists.purpose;

  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;


  id?: number;
  retrievedTextType?: TextTypeDto;
  references: References;

  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<NewTextTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public injectedData: DialogData,
    private notificationService: NotificationService,
    private textTypeService: TextTypeService,
    private sharedService: SharedService
  ) {
    this.id = injectedData?.id;
  }

  ngOnInit(): void {
    this.firstFormGroup = this.fb.group({
      nameCtrl: ['', Validators.required]
    });

    this.secondFormGroup = this.fb.group({
      modesCtrl: [[]],
      domainsCtrl: [[]],
      interactionsCtrl: [[]],
      mediaCtrl: [[]],
      representationsCtrl: [[]],
      purposeCtrl: [[]]
    });


    if (this.id) {
      this.textTypeService.getEntry(this.id).subscribe({
        next: (textType) => this.setForm(textType),
        error: (error) => this.notificationService.openSnackBar(error)
      });
    }
  }

  setForm(textType: TextTypeDto) {
    this.retrievedTextType = textType;
    this.references = this.sharedService.extractReferences(textType)['Verweise'];
    this.firstFormGroup.patchValue({
      nameCtrl: textType.name
    });

    this.secondFormGroup.patchValue({
      modesCtrl: textType.modes || [],
      domainsCtrl: textType.domains || [],
      interactionsCtrl: textType.interactions || [],
      mediaCtrl: textType.media || [],
      representationsCtrl: textType.representations || [],
      purposeCtrl: textType.purpose || []
    });
  }

  createTextType() {
    const dto = new TextTypeDto(
      this.id || 0,
      this.firstFormGroup.controls.nameCtrl.value,
      this.secondFormGroup.controls.modesCtrl.value,
      this.secondFormGroup.controls.domainsCtrl.value,
      this.secondFormGroup.controls.interactionsCtrl.value,
      this.secondFormGroup.controls.mediaCtrl.value,
      this.secondFormGroup.controls.representationsCtrl.value,
      this.secondFormGroup.controls.purposeCtrl.value,
      this.sharedService.getIds(this.references?.vocabCategories),
      this.sharedService.getIds(this.references?.vocabEntries),
      this.sharedService.getIds(this.references?.functionalGrammarCategories),
      this.sharedService.getIds(this.references?.functionalGrammarEntries),
      this.sharedService.getIds(this.references?.systemicGrammarCategories),
      this.sharedService.getIds(this.references?.systemicGrammarEntries),
      this.sharedService.getIds(this.references?.textPatterns),
      this.sharedService.getIds(this.references?.textTypes),
      this.sharedService.getIds(this.references?.detailedCanDoStatementCategories),
      this.sharedService.getIds(this.references?.detailedCanDoStatementEntries),
      this.sharedService.getIds(this.references?.globalCanDoStatementCategories),
      this.sharedService.getIds(this.references?.globalCanDoStatementEntries)
    );

    if (this.retrievedTextType) {
      console.log(this.retrievedTextType);
      this.textTypeService.updateEntry(this.id!, dto).subscribe({
        next: (res) => {
          this.notificationService.openSnackBar(`TextType '${res.name}' bearbeitet`);
          this.dialogRef.close(res);
        },
        error: (error) => this.notificationService.openSnackBar(error)
      });
    } else {
      this.textTypeService.createEntry(dto).subscribe({
        next: (res) => {
          this.notificationService.openSnackBar(`TextType '${res.name}' erstellt`);
          this.dialogRef.close(res);
        },
        error: (error) => this.notificationService.openSnackBar(error)
      });
    }
  }

  handleReferenceChange($event: References) {
    this.references = $event;
  }
}
